import { Component, Input } from '@angular/core';
import { ScreenType } from '@fgb/core';

@Component({
  selector: 'fgb-leaderboard-nav',
  templateUrl: './leaderboard-nav.component.html',
  styleUrl: './leaderboard-nav.component.scss',
})
export class LeaderboardNavComponent {
  @Input() routeLink: string;
  @Input() isRulesEnabled: boolean = false;

  screenType = ScreenType;
}
